import { render, staticRenderFns } from "./CustomerRowRecord.vue?vue&type=template&id=b1c10fee&scoped=true&lang=pug&"
import script from "./CustomerRowRecord.vue?vue&type=script&lang=js&"
export * from "./CustomerRowRecord.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRowRecord.vue?vue&type=style&index=0&id=b1c10fee&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c10fee",
  null
  
)

export default component.exports